
import { bool, number, shape, string } from 'prop-types';

// @todo Create reuseable types

const services = shape({
  description: string.isRequired,
  maxUnits: number.isRequired,
  minimumPrice: shape({
    amount: number.isRequired,
    currencyCode: string.isRequired,
  }).isRequired,
  name: string.isRequired,
  obligatory: bool.required,
  paymentTime: string.isRequired,
  price: shape({
    amount: number.isRequired,
    currencyCode: string.isRequired,
  }).isRequired,
  serviceGroup: number.isRequired,
  serviceId: string.isRequired,
  subGroup: string.isRequired,
  type: string.isRequired,
  unitCount: number.isRequired,
  unitDescription: string.isRequired,
  unitPrice: shape({
    amount: number.isRequired,
    currencyCode: string.isRequired,
  }).isRequired,
});

export { services as default };